// src/mapbox-helpers/global-datasets.ts
import { CustomRasterLayer } from 'src/mapbox-helpers/map-types';

/**
 * NOTE on `url`:
 *  - Must be a standard XYZ tile template: .../{z}/{x}/{y}.png or .jpg
 *  - For GEE-backed layers, this will be your EE map tile URL
 *    (e.g. https://earthengine.googleapis.com/v1/projects/<project>/maps/<mapId>/tiles/{z}/{x}/{y})
 *  - For anything that is not yet tiled, leave the layer OUT of these arrays
 *    until you have a tile url ready.
 */

export const BIODIVERSITY_GLOBAL_LAYERS: CustomRasterLayer[] = [
  // 1) Ecoregions (UNEP-WCMC / GEE vector → raster tiles via your backend)
  {
    id: 'biodiv-ecoregions',
    name: 'Ecoregions',
    type: 'BIODIV_ECOREGIONS',
    url: 'https://data-gis.unep-wcmc.org/server/rest/services/Bio-geographicalRegions/Resolve_Ecoregions/MapServer/tile/{z}/{y}/{x}',
    year: '',
  },

  // 2) Natural Forests of the World 2020
  // {
  //   id: 'biodiv-natural-forest-2020',
  //   name: 'Natural Forests 2020',
  //   type: 'BIODIV_NATURAL_FOREST_2020',
  //   url: 'https://earthengine.googleapis.com/v1/projects/darukaa-earth-product/maps/ab334a7fb405ae137dbc3db7209a757b-94d500e326f70fab37a00c8a511a489f/tiles/{z}/{x}/{y}',
  //   year: '2020',
  // },

  // 3) Global biodiversity intactness (EarthBlox image collection)
  // {
  //   id: 'biodiv-intactness',
  //   name: 'Biodiversity Intactness',
  //   type: 'BIODIV_INTACTNESS',
  //   url: '',
  //   year: '',
  // },

  // 4) Global Wetlands (Resource Watch / or GEE mirror)
  // {
  //   id: 'biodiv-richness',
  //   name: 'Species Richness & Rarity',
  //   type: 'BIODIV_RICHNESS',
  //   url: 'https://earthengine.googleapis.com/v1/projects/darukaa-earth-product/maps/96b4b146376cead70521502164b219d4-bfb725e43bc031fd2f82f44f4e3b467c/tiles/{z}/{x}/{y}',
  //   year: '2024',
  // },

  // // 5) Nighttime Lights (VIIRS)
  // {
  //   id: 'biodiv-nighttime-lights',
  //   name: 'Nighttime Lights (VIIRS)',
  //   type: 'BIODIV_NTL',
  //   url: 'https://earthengine.googleapis.com/v1/projects/darukaa-earth-product/maps/3792ae08d21665448d2487aa2357bc7f-5dbb479a9fabc4f60811cf32cdae38c4/tiles/{z}/{x}/{y}',
  //   year: '2025',
  // },

  // 6) WDPA Protected Areas (if you rasterize / tile it)
  {
    id: 'biodiv-wdpa',
    name: 'Protected Areas (WDPA)',
    type: 'BIODIV_WDPA',
    // TODO: your tile URL after tiling the shapefile / GEE asset
    url: '',
    year: '',
  },

  // 7) IUCN Green List (if you expose tiles)
  {
    id: 'biodiv-iucn-green-list',
    name: 'IUCN Green List Sites',
    type: 'BIODIV_IUCN_GREEN_LIST',
    // TODO: tile URL from your GCS shapefile / GEE asset
    url: '',
    year: '',
  },

  // 7) Emerging hotspots
  // {
  //   id: 'biodiv-emerging-hotspots',
  //   name: 'Emerging Hotspots 2023',
  //   type: 'BIODIV_EMERGINGHOTSPOTS',
  //   url: 'https://earthengine.googleapis.com/v1/projects/darukaa-earth-product/maps/dfa8ba4f400788553c07b6f4e5b66fc2-bc6d6aa54dd4e1953e199c2f1a8f1b63/tiles/{z}/{x}/{y}',
  //   year: '2023',
  // },
];

export const CARBON_GLOBAL_LAYERS: CustomRasterLayer[] = [
  // 1) Above Ground Biomass (global)
  // {
  //   id: 'carbon-agb',
  //   name: 'Above Ground Biomass',
  //   type: 'CARBON_AGB_GLOBAL',
  //   // TODO: EE tile URL – same dataset you already use per-site,
  //   // but configured as a global/background layer.
  //   url: 'https://earthengine.googleapis.com/v1/projects/darukaa-earth-product/maps/4a3e8b4bbc92e739e29207d4c2b48dc7-33be427849eade6c3c2847ab2af683f3/tiles/{z}/{x}/{y}',
  //   year: '2023',
  // },

  // // 2) Below Ground Biomass (if available as tiles)
  // {
  //   id: 'carbon-bgb',
  //   name: 'Below Ground Biomass',
  //   type: 'CARBON_BGB_GLOBAL',
  //   url: 'https://earthengine.googleapis.com/v1/projects/darukaa-earth-product/maps/ed7ec4e0d1528cfe2f4ee1e481eed468-b21b3522307eeafc11acd0ae6168ff72/tiles/{z}/{x}/{y}',
  //   year: '2023',
  // },

  // // 3) Land Cover
  // {
  //   id: 'carbon-landcover',
  //   name: 'Land Cover',
  //   type: 'CARBON_LANDCOVER',
  //   url: 'https://earthengine.googleapis.com/v1/projects/darukaa-earth-product/maps/50a1fc368a4e22011bad3485f58ebf46-0055e9c40099abf69d0d59a81ba49719/tiles/{z}/{x}/{y}',
  //   year: '2025',
  // },

  // // 4) NDVI
  // {
  //   id: 'carbon-ndvi',
  //   name: 'NDVI',
  //   type: 'CARBON_NDVI',
  //   url: 'https://earthengine.googleapis.com/v1/projects/darukaa-earth-product/maps/5f5163503c69cc0c0424d067030e5008-c03ca6d23a839edf001f7842b6bc960d/tiles/{z}/{x}/{y}',
  //   year: '2024',
  // },

  // 5) Soil Organic Carbon (SOC)
  // {
  //   id: 'carbon-soc',
  //   name: 'Soil Organic Carbon',
  //   type: 'CARBON_SOC',
  //   url: 'https://earthengine.googleapis.com/v1/projects/darukaa-earth-product/maps/80de1e8627c4ec821657f50d6802501a-c328f72e5d851bb7f15c09c23948c671/tiles/{z}/{x}/{y}',
  //   year: '',
  // },

  // 6) Canopy Height
  {
    id: 'carbon-canopy-height',
    name: 'Canopy Height',
    type: 'CARBON_CANOPY_HEIGHT',
    url: '',
    year: '',
  },

  // 7) Land Surface Temperature (LST)
  {
    id: 'carbon-lst',
    name: 'Land Surface Temperature',
    type: 'CARBON_LST',
    url: '',
    year: '',
  },

  // 8) Peatland (if you have a tiled peat map)
  {
    id: 'carbon-peatland',
    name: 'Peatlands',
    type: 'CARBON_PEATLAND',
    url: '',
    year: '',
  },

  // 9) Water Body Indices (NDWI / MNDWI)
  {
    id: 'carbon-water-indices',
    name: 'Water Body Indices (NDWI/MNDWI)',
    type: 'CARBON_WATER_INDICES',
    url: '',
    year: '',
  },

  // 10) Volumetric Water Content
  {
    id: 'carbon-volumetric-water',
    name: 'Volumetric Water Content',
    type: 'CARBON_VWC',
    url: '',
    year: '',
  },

  // 11) Fire Hotspots
  {
    id: 'carbon-fire-hotspots',
    name: 'Fire Hotspots',
    type: 'CARBON_FIRE_HOTSPOTS',
    url: '',
    year: '',
  },
];
